@if (tierPrices?.length) {
<div [tradePricingMask]="[product]"
     (tradePricingMaskChange)="updateTierPrices()">
    <div class="_banner p-a-2 bg-col-2 center">
        <h3 class="s1 uppercase"><span class="col-w">{{'BULK' | translate}}</span>&nbsp;<span class="col-7">{{'SAVING' |
                translate}}</span></h3>
    </div>

    @if(displayDragScroll) {
    <div class="m-t  m-t-3-s m-t-3-m no-wrap _dragScroll visible-outside-wrap"
         dragScroll>
        @for (tier of tierPrices; track tier.qty) {
        <div class="inline-flex"
             [class.m-r-2]="!$last"
             [class.m-r]="$last"
             [class.m-l]="$first">
            <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: tier }"></ng-container>
        </div>
        }
    </div>
    } @else {
    <div class="m-t m-t-3-s m-t-3-m"
         [ngClass]="tierPrices.length > 4 ? '_grid' : '_flex'">
        @for (tier of tierPrices; track tier.qty) {
        <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: tier }"></ng-container>
        }
    </div>
    }
</div>
}

<ng-template #itemTpl
             let-tier>
    <div class="_item flex-column center cursor-pointer"
         (click)="selectPrice(tier)">
        <div class="p-a-2 s1">
            @if(tier.sqmPrice && isSqM) {
            {{ tier.sqmQty }}m²+
            <price class="col-2"
                   [value]="tier.sqmPrice"></price>
            {{'per m²' | translate}}
            } @else {
            {{ tier.qty }}+
            <price class="col-2"
                   [value]="tier.price"></price>
            }
        </div>
        @if ( tier.savePercentage) {
        <div class="s1 p-a-1 bg-col-2 col-w w-12">{{'SAVE' | translate}}&nbsp;{{ tier.savePercentage }}%</div>
        }
    </div>
</ng-template>